import * as React from 'react';
import { ArticleHeading4, InformationTooltip, Responsive, UIText2 } from '@cian/ui-kit';
import { IconFunctionalInformation16 } from '@cian/ui-kit-design-tokens/icons';
import * as style from './FullCreditPrice.css';
import { FullCreditPriceModal } from '../FullCreditPriceModal';

interface IFullCreditPriceProps {
  tooltip: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  trackClickHandler?: () => void;
}

export const FullCreditPriceTooltip: React.FC<IFullCreditPriceProps> = props => {
  const { tooltip, placement = 'bottom', trackClickHandler } = props;

  const [open, setOpen] = React.useState(false);

  const onClick = React.useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();

      if (trackClickHandler) {
        trackClickHandler();
      }
      setOpen(true);
    },
    [trackClickHandler],
  );

  const clickTrap = React.useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  }, []);

  return (
    <>
      <Responsive desktop tablet>
        <div className={style['icon']} onClick={clickTrap}>
          <InformationTooltip
            content={
              <div className={style['tooltip']}>
                <ArticleHeading4>Полная стоимость кредита</ArticleHeading4>
                <UIText2 whiteSpace="pre-wrap">{tooltip}</UIText2>
              </div>
            }
            theme="white"
            placement={placement}
          >
            <div className={style['icon--inner']} onClick={trackClickHandler}>
              <IconFunctionalInformation16 color="icon-main-default" />
            </div>
          </InformationTooltip>
        </div>
      </Responsive>

      <Responsive phone>
        <div className={style['icon']} onClick={onClick}>
          <div className={style['icon--inner']}>
            <IconFunctionalInformation16 color="icon-main-default" />
          </div>
        </div>
      </Responsive>

      <FullCreditPriceModal onOpenChange={setOpen} open={open} title="Полная стоимость кредита" description={tooltip} />
    </>
  );
};
